import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppTranslatePipe, NgxBaseCommonModule } from '@kimaya/ngx-base-common-hive';
import { SharedDirectivesModule } from '@progress/kendo-angular-dropdowns';
import { PipesModule } from './pipes';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SharedComponentsModule } from './shared-components';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatToolbarModule } from '@angular/material/toolbar';
import { DirectivesModule } from './directives';
import { NgPipesModule } from 'ngx-pipes';

const COMPONENTS_EXPORT = [];
const COMPONENTS_ENTRY = [];
const COMPONENTS = [...COMPONENTS_EXPORT, ...COMPONENTS_ENTRY];
const MATERIAL_DEFAULT_MODULE = [
  MatButtonModule,
  MatDividerModule,
  MatIconModule,
  MatMenuModule,
  MatDialogModule,
  MatTooltipModule,
  MatInputModule,
  MatFormFieldModule,
  MatSelectModule,
  MatCheckboxModule,
  MatToolbarModule,
];
const MODULES_EXPORT = [
  ...MATERIAL_DEFAULT_MODULE,
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  NgxBaseCommonModule,
  SharedDirectivesModule,
  FlexLayoutModule,
  PipesModule,
  NgSelectModule,
  TranslateModule.forChild(),
  SharedComponentsModule,
  DirectivesModule,
  NgPipesModule
];
const MODULES = [...MODULES_EXPORT];

@NgModule({
  declarations: [...COMPONENTS],
  entryComponents: [...COMPONENTS_ENTRY],
  imports: [...MODULES],
  exports: [...MODULES_EXPORT, ...COMPONENTS_EXPORT],
  providers: [AppTranslatePipe]
})
export class SharedModule {
}
